import { useState } from 'react';
import { useProjectDirectory } from '@/hooks/useProjectDirectory';

const LEGACY_VALUE = '__legacy-project-name__';

export const ProjectSelect = ({ value, onChange, retainedProject = null, testId = 'po-project-select' }) => {
  const { projects, loading, error, refresh } = useProjectDirectory({ includeCompleted: Boolean(retainedProject) });
  const [search, setSearch] = useState('');
  const choices = projects.filter((p) => p.status === 'Ongoing' || p.id === retainedProject?.id);
  if (retainedProject && !choices.some((p) => p.id === retainedProject.id)) {
    choices.push({ ...retainedProject, status: 'Historical' });
  }
  const selectedValue = value || (retainedProject && !retainedProject.id ? LEGACY_VALUE : '');
  const term = search.trim().toLowerCase();
  const visible = choices.filter((p) => p.id === value || `${p.id} ${p.name}`.toLowerCase().includes(term));
  return (
    <div className="mt-1 min-w-0 space-y-2" data-testid={`${testId}-field`}>
      <input type="search" value={search} onChange={(e) => setSearch(e.target.value)}
        aria-label="Search projects" placeholder="Search project name or PRJ code…"
        className="w-full min-w-0 px-3 py-2 border border-gray-300 rounded-lg text-sm"
        data-testid={`${testId}-search`} />
      <select required value={selectedValue} disabled={loading || Boolean(error)}
        aria-label="Project" data-testid={testId}
        className="w-full min-w-0 max-w-full px-3 py-2 border border-gray-300 rounded-lg text-sm disabled:bg-gray-100"
        onChange={(e) => {
          const project = choices.find((p) => (p.id || LEGACY_VALUE) === e.target.value);
          onChange(project ? { id: project.id, name: project.name } : { id: '', name: '' });
        }}>
        <option value="">{loading ? 'Loading projects…' : 'Select project…'}</option>
        {visible.map((p) => <option key={p.id || LEGACY_VALUE} value={p.id || LEGACY_VALUE} data-testid={`${testId}-option-${p.id || 'legacy'}`}>
          {p.id ? `${p.id} — ` : ''}{p.name}{p.status !== 'Ongoing' ? ` (${p.status})` : ''}
        </option>)}
      </select>
      {!loading && !error && visible.length === 0 && <p className="text-sm text-gray-500" data-testid={`${testId}-empty`}>{term ? 'No matching projects.' : 'No Ongoing projects.'}</p>}
      {error && <div role="alert" className="text-sm text-red-700" data-testid={`${testId}-error`}>
        {error} <button type="button" className="underline" onClick={refresh} data-testid={`${testId}-retry`}>Retry</button>
      </div>}
    </div>
  );
};